/**
 * 서브 페이지 연락처 정보 컴포넌트
 * 페이지 좌측에 표시되는 서비스 문의 연락처 박스입니다.
 * height prop에 따라 위치가 동적으로 조정됩니다.
 */

import React from 'react';
import styled from 'styled-components';
import iconTel from '../assets/icon_tel.png';
import {
  SERVICES,
  // FAX_INFO,
  // EMAIL_INFO,
  // MAIN_PHONE,
} from '../constant/contactInfo';

/**
 * SubTel 컴포넌트
 * @param {Object} props
 *
 */
function SubTel() {
  return (
    <Container>
      {/* 제목 영역 */}
      <TitleWrapper>
        <TelIcon src={iconTel} alt="전화 아이콘" />
        <Title>서비스문의</Title>
      </TitleWrapper>

      {/* 연락처 정보 */}
      <ContactInfo>
        <IntroText>친절히 성심성의껏 상담해 드립니다.</IntroText>

        {/* 서비스별 전화번호 */}
        <ServiceList>
          {SERVICES.map((service, index) => (
            <ServiceItem key={index}>
              <ServiceLabel>{service.label}</ServiceLabel>
              <PhoneNumber>{service.phone}</PhoneNumber>
            </ServiceItem>
          ))}
        </ServiceList>

        {/* 기타 연락처 */}
        {/* <AdditionalInfo>
          <InfoText>법인 대표 번호 : {MAIN_PHONE}</InfoText>
          <InfoText>팩스</InfoText>
          <InfoText>- 돌봄 : {FAX_INFO.돌봄}</InfoText>
          <InfoText>- 사회적기업 : {FAX_INFO.사회적기업}</InfoText>
          <InfoText>이메일</InfoText>
          <InfoText>- 돌봄 : {EMAIL_INFO.돌봄}</InfoText>
          <InfoText>- 사회적기업 : {EMAIL_INFO.사회적기업}</InfoText>
        </AdditionalInfo> */}
      </ContactInfo>
    </Container>
  );
}

export default SubTel;

/* Styled Components */

const Container = styled.div`
  /* 데스크톱 기본 스타일 */
  margin-top: 40px;
  width: 230px;
  border: 1px solid #e3e4e4;

  /* 모바일 스타일 - 숨김 */
  @media (max-width: 767px) {
    display: none;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 15px;
  background: #f4f4f4;
  border-bottom: 1px solid #e3e4e4;
`;

const TelIcon = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

const Title = styled.h3`
  font-size: 16px;
  letter-spacing: -1px;
  font-family: 'Nanum Gothic Bold';
  color: #61617a;
  margin: 0;
`;

const ContactInfo = styled.div`
  padding: 15px 12px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const IntroText = styled.p`
  font-family: 'koPubWorld DotumB';
  font-size: 14px;
  letter-spacing: -0.5px;
  color: #333;
  margin: 0;
`;

const ServiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const ServiceItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ServiceLabel = styled.p`
  font-size: 13px;
  font-family: 'koPubWorld DotumB';
  color: #555555;
  font-weight: bold;
  margin: 0;
`;

const PhoneNumber = styled.p`
  font-size: 18px;
  line-height: 1em;
  letter-spacing: -0.5px;
  font-family: 'Nanum Gothic Bold';
  color: #ea4336;
  margin: 0;
`;

const AdditionalInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 5px;
`;

const InfoText = styled.p`
  font-size: 12px;
  font-family: 'koPubWorld DotumB';
  color: #333333;
  margin: 0;
`;
